module.exports = __webpack_public_path__ + "1cc67918996f4fc1bf637e0683c178cc.svg";